import React, { useCallback } from 'react';
import { SegmentFilter } from 'src/gqlReactTypings.generated.d';
import styled from 'styled-components';
import { Icon, IconName } from 'web-common/src/shared/design-system/components/Icon';
import { Colors, ScreenWidth } from 'web-common/src/shared/styles';

const SegmentFilterSelector = styled.div`
  cursor: pointer;
  display: inline-block;
  margin: 0 1px;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &.grayscale {
    img {
      filter: grayscale(100%);
    }
  }
`;
const SegmentSelectorTitleDiv = styled.div`
  height: 20px;
  position: relative;
  @media screen and (max-width: ${ScreenWidth.SMALL}) {
    width: 85px;
  }
  margin-bottom: 10px;
`;
const SegmentSelectorTitle = styled.p`
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  text-transform: capitalize;
  color: ${Colors.GRAY_DARK_30};
`;

interface IProps {
  segmentFilter: SegmentFilter | null;
  icon: IconName;
  hoverIcon: IconName;
  title?: string;
  active?: boolean;
  onClick: (segmentFilter: SegmentFilter | null) => void;
  iconWidth?: 48 | 100;
  style?: React.CSSProperties;
  colored?: boolean;
}

export const SegmentFilterIcon = ({
  segmentFilter,
  icon,
  hoverIcon,
  title,
  active = false,
  style,
  onClick,
  iconWidth = 48,
  colored = true,
}: IProps) => {
  const [hover, setHoverState] = React.useState<boolean>(false);

  const mouseEnter = React.useCallback(() => setHoverState(true), []);
  const mouseLeave = React.useCallback(() => setHoverState(false), []);

  // Do not actually send "all" as a segment filter. Treat it as a null
  // filter:
  const segmentFilterIfNotAll = segmentFilter !== SegmentFilter.All ? segmentFilter : null;
  const handleSegmentFilterClick = useCallback(() => onClick(segmentFilterIfNotAll), [segmentFilterIfNotAll, onClick]);

  return (
    <SegmentFilterSelector
      data-cy={`cuisine-filter-${segmentFilter?.toLowerCase()}`}
      className={`center ${colored ? '' : 'grayscale'}`}
      onClick={handleSegmentFilterClick}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}>
      <Icon name={hover || active ? hoverIcon : icon} size={iconWidth} style={style} />
      {title && (
        <SegmentSelectorTitleDiv>
          <SegmentSelectorTitle style={{}}>{title.replace(/_/g, ' ')}</SegmentSelectorTitle>
        </SegmentSelectorTitleDiv>
      )}
    </SegmentFilterSelector>
  );
};
